import React, { FC, useCallback } from 'react';

import WorkspaceFields from '../../WorkspaceFields';
import ControlBtns from './ControlBtns';
import { accessFields, accessInitialValues, accessRadio, WORKSPACE_ACTIONS } from 'src/constants/workspacesConstants';
import { userAccessValidationSchema } from 'src/helpers/workspacesHelpers';
import { TAccessSubmitValues } from 'src/interfaces/WorkspacesTypes';

type TAccessActionProps = {
  action: WORKSPACE_ACTIONS;
  onClose: () => void;
  onConfirm: (value: TAccessSubmitValues) => void;
  inputValue?: Record<string, string>;
};

const AccessAction: FC<TAccessActionProps> = ({ onClose, onConfirm, action, inputValue }) => {
  const onSubmit = useCallback(
    (values: TAccessSubmitValues) => {
      onConfirm(values);
    },
    [onConfirm]
  );

  return (
    <WorkspaceFields
      onSubmit={onSubmit}
      initialValues={accessInitialValues[action]}
      schema={userAccessValidationSchema[action]}
      fileds={accessFields(action, inputValue)}
      radioBtns={accessRadio}
      size="sm"
      actionBtn={({ isDisabled }) => (
        <ControlBtns onClose={onClose} isDisabledConfirm={isDisabled} buttonType="submit" />
      )}
    />
  );
};

export default AccessAction;
